







































































import {
  Component,
  Vue
} from 'vue-property-decorator';
import WelcomePopUp from '@/components/WelcomePopUp.vue'
@Component({
  components: {
    WelcomePopUp
  }
})
export default class Home extends Vue {
  private opacity = 'opacity:1';
  onScroll(e) {
    /* The first number adjusts how long it takes to start the fade,
      second number adjusts how long the fading lasts */
    let newOpacity: number = 1.3 - e.target.scrollTop / 125;
    if (newOpacity < 0) {
      newOpacity = 0;
    } else if (newOpacity > 1) {
      newOpacity = 1;
    }
    this.opacity = 'opacity:' + newOpacity;
  }
}
